import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import HotelTransactionDetailsSkeletonWeb from "./layouts/HotelTransactionDetailsSkeleton.web";
import HotelTransactionDetailsSkeletonMob from "./layouts/HotelTransactionDetailsSkeleton.mob";

const HotelTransactionDetailsSkeletonComponent = withConditionalComponent(HotelTransactionDetailsSkeletonWeb, HotelTransactionDetailsSkeletonMob);

export default function HotelTransactionDetailsSkeleton() {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <HotelTransactionDetailsSkeletonComponent trigger={isLargeScreen} />;
}
